import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, SearchCriteria, FacetSearchCriteria, FacetRenderMode, Preset } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { checkAndUpdatePureExpressionDynamic } from '@angular/core/src/view/pure_expression';
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'

@Component({
  selector: 'admin-presets',
  templateUrl: './admin-presets.component.html',
  styleUrls: ['./admin-presets.component.css']
})


export class AdminPresetsComponent implements OnInit {

  @Output()
  onChange = new EventEmitter<any>();

  constructor(private facetedSearchAppService: FacetedSearchAppService, public confirmDialog: MatDialog) {
  }

  onReorder(e: any) {
    let displayOrder: number = 1;
    for (let i = 0; i < this.facetedSearchAppService.presets.length; i++) {
      this.facetedSearchAppService.presets[i].displayOrder = displayOrder++;
    }
    this.facetedSearchAppService.updatePresets();
  }

  onDeletePreset(deleted: Preset) {
    let dialogRef = this.confirmDialog.open(ConfirmationDialogComponent, {
      data: {
        title: "Delete Pre-set",
        text: "Are you sure you want to delete pre-set \"" + deleted.presetName + "\"?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log("afterConfirmDialog: result" + result);
      if (result) {
        this.facetedSearchAppService.presets = this.facetedSearchAppService.presets.filter(x => x.id != deleted.id);
        this.facetedSearchAppService.deletePreset(deleted.id);
      }
    });
  }

  onPresetNameChange(updatedPreset: Preset) {

    let p = this.facetedSearchAppService.presets.filter(x => x.id == updatedPreset.id) || null;
    if (p != null) {
      p[0].presetName = updatedPreset.presetName;
    }
    this.facetedSearchAppService.updatePreset(updatedPreset);
  }


  ngOnInit(): void {

  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/admin-presets/admin-presets.component.ts